/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
import { createTypedHooks, State as EzPzState } from 'easy-peasy';

import * as adminDashboard from './adminDashboard';
import * as architectScene from './architectScene';
import * as confirmDialog from './confirmDialog';
import * as dataCategory from './dataCategory';
import * as drive from './drive';
import * as driveList from './driveList';
import * as organization from './organization';
import * as recordingTag from './recordingTag';
import * as recordingUpload from './recordingUpload';
import * as shortcut from './shortcut';
import * as toast from './toast';
import * as user from './user';
import * as vizScene from './vizScene';

const rootModel = {
  adminDashboard: adminDashboard.model,
  drive: drive.model,
  architectScene: architectScene.model,
  driveList: driveList.model,
  toast: toast.model,
  confirmDialog: confirmDialog.modal,
  shortcut: shortcut.model,
  user: user.model,
  organization: organization.model,
  vizScene: vizScene.model,
  dataCategory: dataCategory.model,
  recordingTag: recordingTag.model,
  recordingUpload: recordingUpload.modal,
};

const typedHooks = createTypedHooks<typeof rootModel>();
export const { useStoreActions } = typedHooks;
export const { useStoreDispatch } = typedHooks;
export const { useStoreState } = typedHooks;
export type State = EzPzState<typeof rootModel>;
export default rootModel;
